export default __webpack_public_path__ + "static/media/sports1.7964c5e2.JPG";